var map = {
	"./advance.png": 5667,
	"./business.png": 445,
	"./electron.png": 2198,
	"./industrial.png": 1846,
	"./innovation.png": 9401,
	"./junior.png": 8492,
	"./lawyer.png": 7752,
	"./turism.png": 5465,
	"./web.png": 1703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9540;